import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { SignUpPage } from './pages/SignUpPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { PlaysPage } from './pages/PlaysPage'
import { PlayDetailPage } from './pages/PlayDetailPage'
import { AddProductionPage } from './pages/AddProductionPage'
import { LogEntryPage } from './pages/LogEntryPage'
import { ProfilePage } from './pages/ProfilePage'
import { DiaryPage } from './pages/DiaryPage'
import { WantToWatchPage } from './pages/WantToWatchPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'

function App() {
  useEffect(() => {
    const hash = window.location.hash
    if (hash && hash.includes('type=recovery')) {
      window.location.replace('/reset-password' + hash)
    }
  }, [])

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plays"
            element={
              <ProtectedRoute>
                <PlaysPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plays/:id"
            element={
              <ProtectedRoute>
                <PlayDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productions/new"
            element={
              <ProtectedRoute>
                <AddProductionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/log"
            element={
              <ProtectedRoute>
                <LogEntryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/diary"
            element={
              <ProtectedRoute>
                <DiaryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/want-to-watch"
            element={
              <ProtectedRoute>
                <WantToWatchPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
